import {
    createHandlerChainRunner,
    HandlerWithResult,
    markSkipOnCompleteIfOnSuccessIsSet,Handler
} from "@insite/client-framework/HandlerCreator";
import { updateOrderSchedule as UpdateOrderSchedule,UpdateOrderScheduleApiParameter } from "@TKCCP/Services/tkccpOrderReminderService";
import loadOrderReminder from "@TKCCP/Store/Data/OrderReminder/Handlers/LoadOrderReminder";
import {OrderEmailScheduleModel} from "@TKCCP/Types/ApiModels";

type HandlerType = Handler<
    {
        orderNumber: string;
        schedule: OrderEmailScheduleModel | null;
        onSuccess?: () => void;
    },
    {
        orderEmailScheduleModel: OrderEmailScheduleModel | null;
    }
>;

export const RequestDataFromApi: HandlerType = async props => {
   
    props.orderEmailScheduleModel = await UpdateOrderSchedule({
        orderNumber: props.parameter.orderNumber,
        orderEmailScheduleModel : props.parameter.schedule,
    } as UpdateOrderScheduleApiParameter
    );
};

export const ResetOrderScheduleData: HandlerType = props => {
    props.dispatch({
        type : "Data/OrderReminder/Reset" as any,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const LoadOrderSchedular: HandlerType = props => {
    //if (props.orderEmailScheduleModel) {
        props.dispatch(
            loadOrderReminder({
                orderNumber: props.parameter.orderNumber,
            }),
        );
    //}
};

export const chain = [RequestDataFromApi,ResetOrderScheduleData, ExecuteOnSuccessCallback,LoadOrderSchedular];

const updateOrderReminderSchedule = createHandlerChainRunner(chain, "UpdateOrderReminderSchedule");
export default updateOrderReminderSchedule;
